export function companyUserHome(role, isPhone) {
    if (role === 'service_admin' || role === 'service_viewer') return '/shop';
    if (role === 'company_admin') return '/forms-management?tab=0';
    return role === 'company_user' && isPhone ? '/forms/weekly-checklist' : '/dashboard';
}
